export default __webpack_public_path__ + "static/media/25.1ae3da16.png";